import { type Row } from '@/lib/types';
import { createContext } from 'react';

const RowContext = createContext<Row>(null as unknown as Row);

export default RowContext;
